import { ProductModel } from "../../Model/CatalogueModel";

export const checkImageExists = (url?: string): Promise<boolean> =>
  new Promise((resolve) => {
    if (!url) return resolve(false);

    const img = new Image();
    img.src = url;
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });

export const filterProductsWithValidImages = async (
  products: ProductModel[]
): Promise<ProductModel[]> => {
  const validated = await Promise.all(
    products.map(async (product) => ({
      ...product,
      hasValidImage: await checkImageExists(product.photo),
    }))
  );

  return validated.filter((p) => p.hasValidImage);
};
